import { useEffect } from 'react';
//
import useStageMode from '../useStageMode';
import HeroStage, { HeroMode } from './HeroStage';

// ----------------------------------------------------------------------

function useHeroPlayed() {
  useEffect(() => {
    const root = document.documentElement;

    let timer = 0;

    const start = () => {
      timer = window.setTimeout(() => root.classList.add('hero-played'), 2400);
    };

    const observer = new MutationObserver(() => {
      if (root.classList.contains('fonts-ready')) {
        observer.disconnect();
        start();
      }
    });

    if (root.classList.contains('fonts-ready')) {
      start();
    } else {
      observer.observe(root, { attributes: true, attributeFilter: ['class'] });
    }

    return () => {
      observer.disconnect();
      window.clearTimeout(timer);
    };
  }, []);
}

export default function Hero() {
  const { heroPinned, reduced } = useStageMode();

  const mode: HeroMode = reduced ? 'static' : heroPinned ? 'pinned' : 'flow';

  useHeroPlayed();

  return <HeroStage key={mode} mode={mode} />;
}
